module.exports = __webpack_public_path__ + "static/bonus-content-badge.efc333ce.png";